<div [ngClass]="['input-container']">
    <!-- <ng-container *ngIf="date; else useControl">
        <nz-date-picker [nzPlaceHolder]='placeholder' [ngModel]=""
            (ngModelChange)="onChange($event)" [ngClass]="['input', 'form-input']" [ngStyle]="style"
            [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat">
        </nz-date-picker>
    </ng-container>
    <ng-template #useControl> -->
        <nz-date-picker 
            [nzShowTime]="showTime" 
            [formControl]="control" 
            [nzPlaceHolder]='placeholder'
            [ngClass]="['input', 'form-input']" 
            [nzDisabledDate]="disabledDate" 
            [nzDisabled]="disabled"
            [nzAllowClear]="allowClear"
            [nzLocale]="locale"
            >
        <!-- [ngStyle]="style" -->
        </nz-date-picker>
    <!-- </ng-template> -->
</div>
